<!-- Start Copyright End -->
<div class="copyrights-area p-3">
    <div class="row align-items-center">
        <div class="col-lg-6 col-sm-6 col-md-6">
            <p>© 2024 Adorn Tourism All Rights Reserved.</p>
        </div>
        <div class="col-lg-6 col-sm-6 col-md-6 text-end">
            <p>Designed by <a href="https://adorntourism.com/" target="_blank">Adorn Tourism</a></p>
        </div>
    </div>
</div>
<!-- End Copyright End -->